import { render, staticRenderFns } from "./cfdeScope2Design.vue?vue&type=template&id=713c38e0&scoped=true"
import script from "./cfdeScope2Design.vue?vue&type=script&lang=js"
export * from "./cfdeScope2Design.vue?vue&type=script&lang=js"
import style0 from "./cfdeScope2Design.vue?vue&type=style&index=0&id=713c38e0&lang=css"
import style1 from "./cfdeScope2Design.vue?vue&type=style&index=1&id=713c38e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c38e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713c38e0')) {
      api.createRecord('713c38e0', component.options)
    } else {
      api.reload('713c38e0', component.options)
    }
    module.hot.accept("./cfdeScope2Design.vue?vue&type=template&id=713c38e0&scoped=true", function () {
      api.rerender('713c38e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeScope2Design.vue"
export default component.exports